import axios from 'axios';
import config from '../config';
import {
    OnboardDeviceHardwareConfiguration,
    OnboardDeviceHardwareConfigurationRequestBody,
} from '../interfaces';

export const putOnboardDevicesHardwareConfiguration = (
    id: string,
    request: OnboardDeviceHardwareConfigurationRequestBody,
): Promise<OnboardDeviceHardwareConfiguration> => {
    return axios
        .put(`${config.API_URL}/onboard-devices/hardware-configurations/${id}`, request)
        .then((response: any) => {
            return response.data;
        });
};
